import React from 'react';

import useMediaQuery from '@/Utils/useMediaQuery';

type BaseModalProps = {
  icon: string;
  title: string;
  text: React.ReactNode;
  cancelButton?: boolean | null;
  primaryButtonText: string;
  handlePrimaryButton: () => void;
  handleCancel?: () => void;
  isLoading?: boolean;
};

const BaseModal: React.FC<BaseModalProps> = ({
  handleCancel,
  title,
  text,
  cancelButton,
  primaryButtonText,
  handlePrimaryButton,
  icon,
  isLoading,
}) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <div
      className={`flex flex-col gap-10 h-full ${isMobile ? 'p-7' : ''}`}
      style={!isMobile ? { margin: '0.7rem -1.8rem' } : undefined}
    >
      <div className='flex gap-5 items-center justify-left'>
        <img src={icon} alt='' />
        <h2
          className='font-bold text-24px font-serif'
          style={{ letterSpacing: '-1px' }}
        >
          {title}
        </h2>
      </div>
      <p className='text-16px font-serif'>{text}</p>
      <div className='flex flex-col sm:flex-row justify-center gap-8 w-full'>
        {cancelButton && (
          <button className='btn-cancel w-full' onClick={handleCancel}>
            Cancel
          </button>
        )}
        <button
          className='btn w-full whitespace-nowrap'
          onClick={handlePrimaryButton}
          disabled={isLoading}
        >
          {isLoading ? 'Processing...' : primaryButtonText}
        </button>
      </div>
    </div>
  );
};
export default BaseModal;
